import axios from '@axios';
import { ErrorMessage } from '@/libs/Error';

export default class SLSItemExClient {
  constructor() {
    this.api = axios;
    this.error = new ErrorMessage();
  }

  async getItems(queries = {}) {
    try {
      const { data } = await this.api.get('/custom-field');
      return data;
    } catch (error) {
      throw this.error.message(error, 'Erro ao listar os items');
    }
  }

  async index(queries = {}) {
    try {
      const { data } = await this.api.get('/custom-field?showAll=true', { params: queries });
      return data;
    } catch (error) {
      throw this.error.message(error, 'Erro ao listar os Campo Customizado');
    }
  }

  async store(data) {
    try {
      const { data: response } = await this.api.post('/custom-field', data);
      return response;
    } catch (error) {
      throw this.error.message(error, 'Erro ao criar Campo Customizado');
    }
  }

  async show(id) {
    try {
      const { data } = await this.api.get(`/custom-field/${id}`);
      return data;
    } catch (error) {
      throw this.error.message(error, 'Erro ao buscar Campo Customizado');
    }
  }

  async update(id, data) {
    try {
      const { data: response } = await this.api.put(`/custom-field/${id}`, data);
      return response;
    } catch (error) {
      throw this.error.message(error, 'Erro ao atualizar Campo Customizado');
    }
  }

  async destroy(id) {
    try {
      const { data: response } = await this.api.delete(`/custom-field/${id}`);
      return response;
    } catch (error) {
      throw this.error.message(error, 'Erro ao deletar Campo Customizado');
    }
  }
}
